import { render, staticRenderFns } from "./metrics_drill_down.vue?vue&type=template&id=63def96d&scoped=true&"
import script from "./metrics_drill_down.vue?vue&type=script&lang=js&"
export * from "./metrics_drill_down.vue?vue&type=script&lang=js&"
import style0 from "./metrics_drill_down.vue?vue&type=style&index=0&id=63def96d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63def96d",
  null
  
)

export default component.exports